export default __webpack_public_path__ + "static/media/tbicon.c67f2e07.svg";